import { defineStore } from 'pinia';

const INITIAL_INDEX = 50;

export const useModalStackStore = defineStore('modalStack', () => {
  const modalStack = ref<string[]>([]);

  const isFirstModal = (id: string) => modalStack.value.length > 0 && modalStack.value[0] === id;
  function getIndex(id: string) {
    const index = modalStack.value.findIndex((modalId) => modalId === id);
    if (index < 0) return INITIAL_INDEX;
    return INITIAL_INDEX + index;
  }

  function pushModal(id: string) {
    const index = modalStack.value.findIndex((modalId) => modalId === id);
    if (index >= 0) return;
    modalStack.value.push(id);
  }

  function popModal(id: string) {
    const index = modalStack.value.findIndex((modalId) => modalId === id);
    if (index !== -1) {
      modalStack.value.splice(index, 1);
    }
  }

  const clearStack = () => (modalStack.value = []);

  return {
    modalStack: readonly(modalStack),
    pushModal,
    popModal,
    isFirstModal,
    getIndex,
    clearStack
  };
});
